'use strict';

module Patersons {

    export class BearerInjector {

        tokenService: TokenService;
        q: ng.IQService;
        baseUrl: string;

        static $inject = ['$q', 'tokenService'];
        constructor( $q, tokenService) {
            this.q = $q;
            this.tokenService = tokenService;
            var model: string = document.getElementById("model").textContent.trim();
            var dictionary: any = JSON.parse(model);
            this.baseUrl = dictionary['hostPath'];
        }

        request = (config) => {
            if (config.url.indexOf(this.baseUrl, 0) == 0 || config.url.indexOf("assets/templates")== 0)
            {
                var token = this.tokenService.tokenManager.access_token;
                if (token) {
                    console.log('Adding authorization header for request: ' + config.url);
                    config.headers['Authorization'] = 'Bearer ' + token;
                }
            }
            return config;
        };

        responseError = (response) => {
            var x = response;
            console.log(response);
            if (response.status === 401 && response.config.url.indexOf("https://api-global.morningstar.com") === -1) {
                //Store current URL to redirect back to it after login.
                window.localStorage.setItem('$psl.redirect_uri', window.location.href);
                this.tokenService.tokenManager.redirectForToken();
            }
            if (response.status === 403) {
                //identityService.tokenManager.removeToken();
            }
            return this.q.reject(response);
        }
    }
}
